/** Libellés et helpers identité patient (nom, prénom, sexe). */

export const PATIENT_GENDER_VALUES = ['Homme', 'Femme'];

export const PATIENT_GENDER_OPTIONS = PATIENT_GENDER_VALUES.map((value) => ({
  value,
  label: value,
}));

export function formatPatientGender(gender) {
  if (gender === 'Homme' || gender === 'Femme') return gender;
  if (gender === 'male') return 'Homme';
  if (gender === 'female') return 'Femme';
  return gender || '—';
}

export function normalizePatientGender(gender) {
  if (gender === 'Homme' || gender === 'Femme') return gender;
  if (gender === 'male') return 'Homme';
  if (gender === 'female') return 'Femme';
  return '';
}

/**
 * Nom affiché : prénom + nom, ou repli sur `name` (anciens dossiers).
 */
export function formatPatientDisplayName(patient) {
  const first = (patient?.first_name || '').trim();
  const last = (patient?.last_name || '').trim();
  const combined = [first, last].filter(Boolean).join(' ');
  if (combined) return combined;
  return (patient?.name || '').trim() || '—';
}

export function buildPatientNameFromParts(firstName, lastName) {
  return [firstName, lastName].map((s) => String(s || '').trim()).filter(Boolean).join(' ');
}

export function buildPatientInitials(firstName, lastName) {
  const f = String(firstName || '').trim();
  const l = String(lastName || '').trim();
  const parts = [];
  if (f) parts.push(f.charAt(0).toUpperCase());
  if (l) parts.push(l.charAt(0).toUpperCase());
  return parts.join('').slice(0, 2) || '';
}

export function validatePatientIdentityFields({ first_name, last_name, date_birth, gender }) {
  const errors = {};
  if (!String(first_name || '').trim()) errors.first_name = 'Le prénom est obligatoire.';
  if (!String(last_name || '').trim()) errors.last_name = 'Le nom est obligatoire.';
  if (!date_birth) errors.date_birth = 'La date de naissance est obligatoire.';
  const g = normalizePatientGender(gender);
  if (!g) errors.gender = 'Le sexe est obligatoire (Homme ou Femme).';
  else if (!PATIENT_GENDER_VALUES.includes(g)) errors.gender = 'Choisissez Homme ou Femme.';
  return errors;
}
